import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

interface StickyProps {
  children: ReactNode;
  sx?: object;
  orientation?: 'left' | 'right';
  offset?: number;
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
}

export const StickyItem = ({
  children,
  sx,
  orientation = 'left',
  offset = 0,
  position,
}: StickyProps) => {
  const applyTop = position === 'sticky';

  return (
    <Box sx={{ position, [orientation]: offset, ...(applyTop ? { top: 0 } : {}), ...sx }}>
      {children}
    </Box>
  );
};
